module.exports = __webpack_public_path__ + "2dafd975e19d23ac6a7705d7d415dc8c.svg";